/**
 * For apps that open with no signal (Measure2Quote, the portal #391).
 *
 * The shared token getter treats ANY token failure as "sign in again" and
 * redirects to Microsoft — offline, that navigates the app away. So while the
 * device says it's offline, don't ask at all.
 * Known gap: on Wi-Fi with no internet the browser still says "online" and
 * the redirect can fire.
 */

/** Thrown instead of asking for a token while the device has no connection. */
export class OfflineError extends Error {
  constructor(message = 'No connection — changes are saved on this device and will sync later.') {
    super(message);
    this.name = 'OfflineError';
  }
}

/** The token getter, refusing with OfflineError (before any redirect) while the device is offline. */
export function onlineOnly(getToken: () => Promise<string>): () => Promise<string> {
  return async () => {
    if (!navigator.onLine) throw new OfflineError();
    return getToken();
  };
}

/** No connection: refused before asking (OfflineError), or fetch itself failed (TypeError — no response at all). */
export function isConnectionFailure(err: unknown): boolean {
  return err instanceof OfflineError || err instanceof TypeError;
}
